import { render, staticRenderFns } from "./CtrlTokuisaki.vue?vue&type=template&id=71cd2b8b&scoped=true&"
import script from "./CtrlTokuisaki.vue?vue&type=script&lang=ts&"
export * from "./CtrlTokuisaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd2b8b",
  null
  
)

export default component.exports